import { jsx as _jsx } from "react/jsx-runtime";
import { useQueryClient } from '@tanstack/react-query';
import { useOverlayContext } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useLocaleKeys } from '~/i18n';
import { ErrorResponse, ServerError } from '~/infra/ErrorResponse';
import { handleRequest, makeFailure, makeSuccess } from '~/infra/utils';
import { legalTermsModel } from '~/models';
import { useAppConfig, useStoreActions } from '~/store/store-context';
import { CreateDocumentModal } from '../CreateDocumentModal/CreateDocumentModal';
export const useCreateQuillLegalTerms = ()=>{
    const { api } = useStoreActions();
    const queryClient = useQueryClient();
    const { showModal, showSuccessToast, showErrorToast } = useOverlayContext();
    const { generateUniqueId } = useAppConfig();
    const { t: commonTexts } = useLocaleKeys('common');
    const onModalConfirm = async (name, content)=>{
        var _ref;
        const id = generateUniqueId('legalTerms');
        const contentString = content ? JSON.stringify(content.value) : '';
        const result = await handleRequest(api.business.createQuillLegalTerms({
            id,
            name,
            content: contentString
        }));
        if (!result.success) {
            if (result.error instanceof ErrorResponse && result.error.hasServerError(ServerError.LegalTermsNameAlreadyExists)) {
                return makeFailure(ServerError.LegalTermsNameAlreadyExists);
            }
            showErrorToast(commonTexts.toasts.anUnknownErrorHasOccurred());
            return makeFailure('unknown');
        }
        showSuccessToast(commonTexts.toasts.documentCreatedSuccessfully());
        return makeSuccess(legalTermsModel.makeQuillLegalTerms({
            id,
            name,
            origin: 'custom',
            richTextContent: (_ref = content === null || content === void 0 ? void 0 : content.value) !== null && _ref !== void 0 ? _ref : []
        }));
    };
    const createQuillLegalTerms = async ()=>{
        try {
            const newLegalTerms = await showModal({
                biName: 'create_document_modal',
                closeOnEscapeKey: true,
                closeOnClickOutside: true,
                content: (param)=>{
                    let { dismissModal } = param;
                    return /*#__PURE__*/ _jsx(CreateDocumentModal, {
                        onConfirm: onModalConfirm,
                        dismissModal: dismissModal
                    });
                }
            });
            if (!newLegalTerms) {
                return;
            }
            await queryClient.invalidateQueries({
                queryKey: [
                    QueryKeys.LegalTerms
                ]
            });
            return newLegalTerms;
        } catch (unused) {
            return undefined;
        }
    };
    return {
        createQuillLegalTerms
    };
};
